export default __webpack_public_path__ + "static/media/scale.f050a006.png";